export default __webpack_public_path__ + "static/media/christmas7.702d42c3.png";